import React from "react"
import moment from 'moment'

import Header from "../parts/Header"
import HeaderMember from "../parts/HeaderMember"
import AuthActions from '../../actions/AuthActions';
import ScheduleActions from '../../actions/ScheduleActions';
import ScheduleStore from '../../stores/ScheduleStore'
import AuthStore from '../../stores/AuthStore'
import BottomBtnBox from '../parts/BottomBtnBox'
import ScheduleModal from '../parts/ScheduleModal'
import MemberStore from '../../stores/MemberStore'

import config from 'react-global-configuration';
import styles from '../../styles/calendar.css'
/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class CalendarApp extends React.Component {

  constructor(){
    super()
    this.scheduleStoreChangeHandler = this.scheduleStoreChangeHandler.bind(this)
    this.displayInput = this.displayInput.bind(this)
    this.hideInput = this.hideInput.bind(this)
    this.memberStoreChangeHandler = this.memberStoreChangeHandler.bind(this)
    this.event_id = 1
    AuthActions.setAuth()
    this.state = {
      list:[],
      display_input:false,
      member:null
    }
  }

  componentDidMount(){
    ScheduleStore.addChangeListener(this.scheduleStoreChangeHandler)
      MemberStore.addChangeListener(this.memberStoreChangeHandler)
    ScheduleActions.getList(AuthStore.getToken(), this.event_id)

  }


  componentWillUnmount(){
    ScheduleStore.removeChangeListener(this.scheduleStoreChangeHandler)
      MemberStore.removeChangeListener(this.memberStoreChangeHandler)

  }

  memberStoreChangeHandler(){
    const member = MemberStore.getDetail()
    if(member.customer == "live"){
      this.setState({
        member:member
      })
    }


  }
  scheduleStoreChangeHandler(){
    this.setState({
      list:ScheduleStore.getList()
    })
  }

  getNGEntry(target_date){
    for(var i in this.state.list){
      const item = this.state.list[i]
      const d_d = moment(item.target_date)

      if(item.is_ng == 1 && d_d.format("YYYYMMDD") == target_date.format("YYYYMMDD")){
        return item
      }
    }
    return null
  }
  displayInput(){
    this.setState({
      display_input:true
    })
  }
  hideInput(){
    this.setState({
      display_input:false
    })
  }
  deleteItem(id){
    ScheduleActions.delete(AuthStore.getToken(),id ,this.event_id)
  }
  getEntry(target_date){
    var result = []
    for(var i in this.state.list){
      const item = this.state.list[i]
      const d_d = moment(item.target_date)
      if(item.is_ng == 0 && d_d.format("YYYYMMDD") == target_date.format("YYYYMMDD")){
        result.push(item)
      }
    }
    return result
  }
  createBtnHandler(event_id,target_date,comment){
    ScheduleActions.create(AuthStore.getToken(),event_id,target_date,comment )
  }
  render(){

    var now = moment();
    now.subtract(1,"days")
    var current_month = 0

    const cal_html = new Array(90).fill(0).map((d) => {
      now.add(1,"days")
      var th = null
      if(current_month != now.format('M')){
        current_month = now.format('M')
        th = <tr><th colSpan="3" className="month-head">{current_month}月</th></tr>
      }
      const ng_item = this.getNGEntry(now)
      const entries = this.getEntry(now)
      const entry_html = entries.map((item) => {
        const delete_html = this.state.member && this.state.member.id == item.member_id ? <span className="delete_btn" onClick={() => {this.deleteItem(item.id)}}><i className="fas fa-times"></i></span> : null
        return <div className={item.is_instructor ? "schedule-item inst"  : "schedule-item"}>{item.member_picture ? <img src={item.member_picture } className="icon" /> : item.member_name}&nbsp; {item.comment}&nbsp;{delete_html}</div>
      })
      return <tbody>{th}<tr><th className={"d_" + now.day()}>{now.format('D')}</th><td className={ng_item ? "disable" : null}>{ng_item ? "NG" : null}</td><td className={ng_item ? "disable" : null}>{ng_item ? ng_item.comment : null}{entry_html}</td></tr></tbody>
    })

    const input_class = this.state.display_input ? "show" : "no-show"

    return(
      <div>
      <BottomBtnBox　btnClickHandler={this.displayInput} addclass="in"/>
      <ScheduleModal  addclass={input_class} closeBtnHandler={this.hideInput} createBtnHandler={this.createBtnHandler} event_id={this.event_id}/>
      <HeaderMember />
      <main>
        <Header />
        <div className="main-pannel">

        <h1>カレンダー</h1>
          <table className="calendar">
            <thead></thead>
            {cal_html}
          </table>
        </div>
      </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/member/CalendarApp.js